import { render, staticRenderFns } from "./commission-info.pug?vue&type=template&id=f6081556&lang=pug&"
import script from "./commission-info.ts?vue&type=script&lang=ts&"
export * from "./commission-info.ts?vue&type=script&lang=ts&"
import style0 from "./commission-info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports